'use strict';

var keyboardAccessibility = require('base/components/keyboardAccessibility');
var jsCssUtils = require('./injectDynamicUtils');

module.exports = function () {

    var $menuLabel = $('.menu-label-container');

    var clearSelection = function (element) {
        if ($(element).parents('.menu-list').length) {
            $(element).closest('.has-subcategories.show > .dropdown-link').attr('aria-expanded', 'false');
            $(element).closest('.has-subcategories.show').removeClass('show');
            $menuLabel.show();
            $(element).parents('.menu-list').removeClass('submenu-show');
            $('.dropdown-menu').removeClass('submenu-show');
            $(element).closest('.menu-list').children('.top-category')
                .detach();
        } else {
            $(element).closest('.dropdown.show').children('.nav-link').attr('aria-expanded', 'false');
            $(element).closest('.dropdown.show').removeClass('show');
            $menuLabel.show();
            $(element).closest('.dropdown').children('.dropdown-menu').children('.top-category')
                .detach();
            $('.main-menu').removeClass('submenu-show');

            if ($('.navigation-redesign').length) {
                $('.menu-group').removeClass('overflow-hidden');
            }
        }
    };

    var clearMobileMenu = function () {
        $('.dropdown-menu, .menu-list, .main-menu').removeClass('submenu-show');
        $('.navbar-nav').find('.top-category').detach();
        $('.navbar-nav').find('.nav-menu').detach();
        $('.navbar-nav').find('.show').removeClass('show');
        $menuLabel.show();
        $('.menu-toggleable-left').removeClass('in');
        $('.modal-background').hide();
    };

    $('body').on('click', '.close-main-menu', function (e) {
        e.preventDefault();
        $('body').removeClass('lock-position');
        $('html').removeClass('fix-position');
        $('.menu-group').removeClass('overflow-hidden');
        $('.menu-group').scrollTop(0);
        $('.dropdown-menu').scrollTop(0);
        $('.close-menu').hide();
        $('body').trigger('hamburgerMenu:close');
        clearMobileMenu();
    });


    var isDesktop = function () {
        return false;
    };

    // handle PUR Renew Click
    $('body').on('click', '.pur-renew-redesign', function (e) {
        e.preventDefault();
        var $showAccountModal = $('#showAccountModal');
        $showAccountModal.modal('hide');
        $('body').removeClass('modal-open');
        var $proRenewModal = $('#proRenewModal');
        if ($proRenewModal.length === 0) {
            let url = $(this).data('href');
            const purRenewMagazine = $(this).data('renew-id') ? $(this).data('renew-id').toLowerCase() : $('#proMagazineFormatDefaultSelection').val();
            $.ajax({
                url: url,
                method: 'get'
            }).done(function (data) {
                if (data) {
                    $('body').append(data.modalHtml);
                    $('#proRenewModal').modal({ show: true });
                    $('body').addClass('modal-open');
                    jsCssUtils.injectDynamicJs('#online-enrollment-js-url');
                    let $radioBtnContainer = $('#proRenewModal .pro-tile');
                    if ($radioBtnContainer.length) {
                        $radioBtnContainer.removeClass('selected');
                        $radioBtnContainer.find('input[name=option-magazineFormat]').attr('checked', false);
                        const $selectedRadioButton = $radioBtnContainer.find('#' + purRenewMagazine);
                        $selectedRadioButton.parent().addClass('selected');
                        $selectedRadioButton.find('input[name=option-magazineFormat]').attr('checked', 'checked');
                    }
                }
            });
        }
    });

    $('.header-banner .close').on('click', function () {
        $('.header-banner').addClass('hide');
    });

    $(document).on('click', '.logout-anchor', function () {
        $('body').trigger('store:removeCachedHtml');
    });

    $('body').on('click', '.l1, .l2, .js-viewall, .staticlink, .hamburger-desktop, .header-mobile-menu', function (event) {
        event.stopPropagation();
        var level1Cat;
        var level2Cat;
        var catData;
        var catDetails;
        var isDesktopView = isDesktop();
        var region = $(this).parents('.hamburger-nav-container').length;
        var regionArea = region || !isDesktopView ? 'Hamburger' : 'Header';
        var userAgent = isDesktopView ? 'desktop' : 'mobile';
        var displayStatus = $(this).find('.mobile-nav-icon').length ? $(this).find('.mobile-nav-icon').css('display') : 'none';
        var state = displayStatus === 'none' && userAgent === 'mobile' ? 'linkClick' : 'linkOpen';
        var level1Class = $(this).find('.js-level1-cat');
        var level2Class = $(this).find('.js-level2-cat');
        var l1Check = $(this).hasClass('l1');
        var l2Check = $(this).hasClass('l2');
        var js1 = $(this).hasClass('js1');
        var l1DropdownCheck = $(this).hasClass('dropdown-toggle l1');
        var jsViewAll = $(this).hasClass('js-viewall');
        var toggleAvailability = $(this).is('[data-hamburger-list-toggle]');
        var hamBurgur = regionArea === 'Hamburger' && toggleAvailability ? 'linkOpen' : 'linkClick';
        var displayStatusDesk = $(this).find('.mobile-nav-icon').length ? 'linkOpen' : hamBurgur;
        if (l1Check) {
            level1Cat = level1Class.attr('data-catName1');
            catData = level1Cat;
            catDetails = level1Cat;
            state = userAgent === 'desktop' ? displayStatusDesk : state;
        } else if (l2Check || jsViewAll) {
            level2Cat = level2Class.attr('data-catName2');
            level1Cat = level2Class.attr('data-catName1');
            catData = level1Cat + ':' + level2Cat;
            catDetails = level1Cat + '/' + level2Cat;
            if (jsViewAll) {
                catData = js1 ? $(this).attr('data-catName1') : $(this).attr('data-catName1') + ':' + $(this).attr('data-catName2');
                catDetails = js1 ? $(this).attr('data-catName1') : $(this).attr('data-catName1') + '/' + $(this).attr('data-catName2');
            }
            state = userAgent === 'desktop' ? 'linkClick' : state;
        }
        if (l1DropdownCheck) {
            $('body').trigger('site:navigation', { categoryData: catData, state: 'linkOpen', regionArea: regionArea, categoryDetails: catDetails });
        } else if ((!isDesktopView && l1Check) || l2Check || jsViewAll) {
            $('body').trigger('site:navigation', { categoryData: catData, state: state, regionArea: regionArea, categoryDetails: catDetails });
        }
        if ($(this).hasClass('hamburger-desktop') || $(this).hasClass('header-mobile-menu')) {
            $('body').trigger('site:navigation', { categoryData: 'Hamburger', state: 'linkOpen', regionArea: 'Hamburger', categoryDetails: catDetails });
        }
        if ($(this).hasClass('staticlink')) {
            $('body').trigger('site:navigation', { categoryData: $(this).find('.user-message').text(), state: 'linkClick', regionArea: 'Hamburger', categoryDetails: catDetails });
        }
    });

    keyboardAccessibility('.main-menu .nav-link, .main-menu .dropdown-link',
        {
            40: function (menuItem) { // down
                if (menuItem.hasClass('nav-item')) { // top level
                    $('.navbar-nav .show').removeClass('show')
                        .children('.dropdown-menu')
                        .removeClass('show');
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    $menuLabel.hide();
                    $(this).attr('aria-expanded', 'true');
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                } else {
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $menuLabel.show();
                    $(this).attr('aria-expanded', 'false');
                    menuItem.next().children().first().focus();
                }
            },
            39: function (menuItem) { // right
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $menuLabel.show();
                    $(this).attr('aria-expanded', 'false');
                    menuItem.next().children().first().focus();
                } else if (menuItem.hasClass('dropdown')) {
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    $menuLabel.hide();
                    $(this).attr('aria-expanded', 'true');
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                }
            },
            38: function (menuItem) { // up
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                } else if (menuItem.prev().length === 0) {
                    menuItem.parent().parent().removeClass('show')
                        .children('.nav-link')
                        .attr('aria-expanded', 'false');
                    menuItem.parent().parent().children().first()
                        .focus();
                } else {
                    menuItem.prev().children().first().focus();
                }
            },
            37: function (menuItem) { // left
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.prev().children().first().focus();
                } else {
                    menuItem.closest('.show').removeClass('show')
                        .closest('li.show').removeClass('show')
                        .children()
                        .first()
                        .focus()
                        .attr('aria-expanded', 'false');
                }
            },
            27: function (menuItem) { // escape
                var parentMenu = menuItem.hasClass('show')
                    ? menuItem
                    : menuItem.closest('li.show');
                parentMenu.children('.show').removeClass('show');
                parentMenu.removeClass('show').children('.nav-link')
                    .attr('aria-expanded', 'false');
                parentMenu.children().first().focus();
            }
        },
        function () {
            return $(this).parent();
        }
    );

    $('.dropdown:not(.disabled) [data-toggle="dropdown"]').on('click', function (e) {
        let isRedesign = $(this).closest('.navigation-redesign').length;
        e.preventDefault();
        /**
         * Hide the search suggestion
         */
        $(document).trigger('hide-suggestion', e);
        // Mobile Menu Category Toggle
        if (!isDesktop()) {
            $('.modal-background').show();
            $('.main-menu').addClass('submenu-show');

            // copy parent element into current UL
            var dropDownItem = $('<div class="dropdown-item top-category" role="button"></div>');
            var link = $(this).clone().removeClass('dropdown-toggle')
                .removeAttr('data-toggle')
                .removeAttr('aria-expanded')
                .attr('aria-haspopup', 'false');
            dropDownItem.append(link);

            if ($(this).parent().children('.dropdown-menu').find('.dropdown-item.top-category').length > 0) {
                $(this).parent().children('.dropdown-menu').find('.dropdown-item.top-category')
                    .remove();
            }

            $(this).parent().children('.dropdown-menu')
                .prepend(dropDownItem);

            if (isRedesign) {
                var $menuGroup = $(this).closest('.menu-group');
                var $viewAllLink = $(this).parent().find('> .view-all-link').clone();
                dropDownItem.append($viewAllLink.addClass('view-link-mobile').removeClass('dropdown-link view-all-link d-none d-lg-block'));

                // removing main scroll after dropdown click
                $menuGroup.scrollTop(0);
                $menuGroup.addClass('overflow-hidden');
            }

            // copy navigation menu into view
            $(this).parent().addClass('show');
            $menuLabel.hide();
            $(this).attr('aria-expanded', 'true');
            $('.close-menu').show();
            // Desktop Menu Category Toggle
        } else if (isRedesign) {
            let $parentContainer = $(this).parent();
            if ($(this).closest('.hamburger-desktop').length) {
                if ($parentContainer.find('.nav-level2-listing').length) {
                    let $firstL1Category = $('.hamburger-list-item.has-multilevel')[0];
                    if ($($firstL1Category).index() === 0) {
                        $parentContainer.children('.dropdown-menu').removeClass('full-width');
                        $($firstL1Category).find('.link-item').trigger('click');
                    }
                } else {
                    $parentContainer.children('.dropdown-menu').addClass('full-width');
                }
            }
        }
    });

    if (isDesktop()) {
        $('.dropdown:not(.disabled) [data-toggle="dropdown"]').on('mouseover', function () {
            $(this).trigger('click');
        });
    }

    $('.has-subcategories:not(.disabled) > .dropdown-link').on('click', function (e) {
        let isRedesign = $(this).closest('.navigation-redesign').length;
        if (!isDesktop()) {
            if (!$(this).parents('.menu-list').hasClass('level-2')) {
                e.preventDefault();
                $('.modal-background').show();
                $(this).closest('.dropdown-menu').addClass('submenu-show');
                $(this).closest('.menu-list').addClass('submenu-show');

                // copy parent element into current UL
                var dropDownItem = $('<li class="dropdown-item top-category" role="button"></li>');
                var link = $(this).clone().removeClass('dropdown-toggle')
                    .removeAttr('data-toggle')
                    .removeAttr('aria-expanded')
                    .attr('aria-haspopup', 'false');
                dropDownItem.append(link);

                if (isRedesign) {
                    var $viewAllLink = $(this).closest('.menu-list').find('.view-all-link').clone();
                    dropDownItem.append($viewAllLink.addClass('view-link-mobile').removeClass('dropdown-link view-all-link d-none d-lg-block'));
                }

                $(this).parent().find('.menu-list').first()
                    .prepend(dropDownItem);

                // copy navigation menu into view
                $(this).parent().addClass('show');
                $(this).parents('.dropdown').addClass('show');
                $menuLabel.hide();
                $(this).attr('aria-expanded', 'true');
            }
        }
    });

    $('.block-layout .level-2 > .has-subcategories > .dropdown-link').on('click', function (e) {
        if (isDesktop()) {
            if (!$(this).parent('.dropdown-item').hasClass('show-sub-menu')) {
                e.preventDefault();
                $(this).parents('.menu-container, .level-2, .dropdown-item').addClass('show-sub-menu');
            }
        }
    });

    $('.main-menu-close-button, .modal-background').on('click', function (e) {
        e.preventDefault();
        $('body').removeClass('lock-position');
        $('html').removeClass('fix-position');
        $('.menu-group').removeClass('overflow-hidden');
        $('.menu-group').scrollTop(0);
        $('.dropdown-menu').scrollTop(0);
        $('.close-menu').hide();
        $('body').trigger('hamburgerMenu:close');
        clearMobileMenu();
    });

    $('.navbar').on('click', '.back .back-to-mainmenu', function (e) {
        e.preventDefault();
        clearSelection(this);
        $('.close-menu').hide();
    });

    $('.navbar-toggler').on('click', function (e) {
        $(document).trigger('hide-suggestion', e).trigger('cancel-search');
        e.preventDefault();
        $('.main-menu').toggleClass('in');
        $('body').toggleClass('lock-position');
        $('html').toggleClass('fix-position');
        $('.modal-background').show();
        var $enableAccountLinkingMobile = $('#enableAccountLinkingMobile');
        var $accountLinkingNav = $('.nav-link.account-linking');
        if ($enableAccountLinkingMobile.length && $enableAccountLinkingMobile.val() === 'true' && sessionStorage.getItem('savedUsernameCookieVal') === 'x') {
            $accountLinkingNav.removeClass('d-none');
        }
    });

    $('.navbar-nav .view-more-option').on('click', function () {
        $(this).siblings('.level-2').toggleClass('view-more');
        $(this).toggleClass('show-all');
    });

    keyboardAccessibility('.header-account-options .user',
        {
            40: function ($popover) { // down
                if ($popover.children('a').first().is(':focus')) {
                    $popover.children('a').first().next().focus();
                } else {
                    $popover.children('a').first().focus();
                }
            },
            38: function ($popover) { // up
                if ($popover.children('a').first().is(':focus')) {
                    $(this).focus();
                    $popover.removeClass('show');
                } else {
                    $popover.children('a').first().focus();
                }
            },
            27: function ($popover) { // escape
                $(this).focus();
                $popover.removeClass('show');
            },
            9: function ($popover) { // tab
                $popover.removeClass('show');
            }
        },
        function () {
            var $popover = $('.user .popover');
            if (!($popover.hasClass('show'))) {
                $popover.addClass('show');
            }
            return $popover;
        }
    );

    $(document).on('mouseenter focusin', '.header-account-options .user', function () {
        if ($('.header-account-options .user .popover').length > 0) {
            $('.minicart .popover').empty();
            $('.minicart .popover').removeClass('show');
            $('.header-account-options .user .popover').addClass('show');
        }
    });


    var $enableAccountLinkingDesktop = $('#enableAccountLinkingDesktop');
    var $accountLinkingNav = $('.additional-info .mem-enrolled');
    $(document).on('mouseleave', '.header-account-options .user', function () {
        $('.header-account-options .user .popover').removeClass('show');
        if ($enableAccountLinkingDesktop.length && $enableAccountLinkingDesktop.val() === 'true') {
            $accountLinkingNav.removeClass('d-none');
        }
    });

    $(document).on('click', '#signIn', function () {
        $('body').removeClass('modal-open');
        var $accountModal = $('#accountModal');
        var $signInModal = $('#signInModal');
        $accountModal.modal('hide');
        $signInModal.modal({ show: true });
        $('body').addClass('modal-open');

        if ($signInModal.length === 0) {
            let url = $(this).data('href');
            $.ajax({
                url: url,
                method: 'get'
            }).done(function (data) {
                if (data) {
                    $('body').append(data);
                    $('#signInModal').modal({ show: true });
                    $('body').addClass('modal-open');
                    $('#login-js-url').data('loaded', false);
                    jsCssUtils.injectDynamicJs('#login-js-url');
                }
            });
        }
    });

    $(document).on('click', '#account-modal-link-nocache, #account-modal-link, #account-modal-link-non-rewards-mbr, #minicart-remove-link', function () {
        $('body').removeClass('modal-open');
        $('body').addClass('header-account-modal-open');
    });

    $(document).one('click', '#minicart-delete-confirmation-btn, #minicart-delete-cancel-btn', function () {
        $('body').removeClass('modal-open');
        $('body').removeClass('header-account-modal-open');
    });

    $(document).on('hidden.bs.modal', '#accountModal, #removeProductModal, #minicart-popover, #signInModal', function () {
        $('body').removeClass('modal-open');
        $('body').removeClass('header-account-modal-open');
    });

    $(document).on('click touchstart', '#createAccountModalLink', function (e, entryPoint, email) {
        $('body').removeClass('modal-open');
        var $createAccountModal = $('#createAccountModal');
        $createAccountModal.modal({ show: true });
        $('body').addClass('modal-open');
        if ($createAccountModal.length === 0) {
            let url = $(this).data('href');
            $.ajax({
                url: url,
                method: 'get'
            }).done(function (data) {
                if (data) {
                    $('body').append(data);
                    $('#login-js-url').data('loaded', false);
                    jsCssUtils.injectDynamicJs('#login-js-url');
                    if (entryPoint === 'fromStoreProfileLogin') {
                        setTimeout(function () {
                            $('.select-register-input').trigger('touchstart');
                            var acctLinkingStep1EmailField = $('.step-1').find('input[type=email]');
                            acctLinkingStep1EmailField.val(email);
                            $('#createAccountModal').modal({ show: true });
                            $('body').addClass('modal-open');
                        }, 150);
                    } else {
                        $('#createAccountModal').modal({ show: true });
                        $('body').addClass('modal-open');
                    }
                }
            });
        }
    });

    $(document).on('click', '#password-reset', function () {
        $('#signInModal').modal('hide');
    });

    $(document).on('show.bs.modal', '#signInModal, #createAccountModal', function () {
        // Injecting Dynamic CSS for account modal
        $('body').trigger('product:beforeAccountModalLoad');
    });

    $(document).on('show.bs.modal', '#showAccountModal', function () {
        var $showAccountModal = $('#main-header-container #showAccountModal');
        if ($showAccountModal.length) {
            $showAccountModal.appendTo('body');
        }
        $('#main-header-container').addClass('account-header-open');
    });

    $(document).on('hidden.bs.modal', '#showAccountModal', function () {
        $('#main-header-container').removeClass('account-header-open');
        $('body').trigger('account:closeSideSheet');
    });

    $('body').on('click.menu', function (e) {
        let isRedesign = $('.navigation-redesign').length;
        var target = e.originalEvent && e.originalEvent.target ? e.originalEvent.target : e.target;
        var $clickedElement = $(target);
        if (!$clickedElement.parents('.navbar-nav').length) {
            $('.navbar-nav').find('.show').removeClass('show');
        }

        if (isRedesign) {
            if (!$clickedElement.parents('.hamburger-desktop').length) {
                $('.hamburger-desktop').removeClass('show');
                $('.hamburger-desktop').find('.show').removeClass('show');
            }
            $('body').removeClass('disableScroll');
        }
    });

    $('div[class^="home-hero"], .console-landing-hero').each(function () {
        var $ctaButton = $(this).find('.btn-primary, .btn-outline-primary, .btn.primary');
        if ($ctaButton.length) {
            $(this).css('cursor', 'pointer');
            $(this).on('click', function () {
                $ctaButton[0].click();
            });
        }
    });

    $('body').on('shown.bs.modal', '#createAccountModal', function () {
        $('#signInModal').modal('hide');
        $('#createAccountModal').appendTo('body');
    });

    $('body').on('shown.bs.modal', '#signInModal', function () {
        $('#accountModal').modal('hide');
        $('body').addClass('modal-open');
    });

    $('body').on('product:beforeAddToCart pur:beforeAddToCart', function () {
        jsCssUtils.injectDynamicJs('#base-events-js-url');
    });
};
